import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Check(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 16 12">
      <path d="M4.243 11.186c.257.257.514.385.9.385s.643-.128.9-.385l9-9a1.243 1.243 0 000-1.8 1.243 1.243 0 00-1.8 0l-8.1 8.1-2.957-2.957a1.243 1.243 0 00-1.8 0 1.243 1.243 0 000 1.8l3.857 3.857z"></path>
    </IconSvg>
  );
}
